function l_isReturningVisitorAfterSession() {
	const firstVisitId = localStorage.getItem('hasVisited')
	let currentSessionId = sessionStorage.getItem('sessionStarted')

	if (!currentSessionId) {
		currentSessionId = Date.now()
		sessionStorage.setItem('sessionStarted', currentSessionId)
	}

	if (!firstVisitId) {
		localStorage.setItem('hasVisited', currentSessionId)
	}

	if (firstVisitId && currentSessionId && firstVisitId != currentSessionId) {
		window.isReturningCustomer = true
		document.dispatchEvent(
			new CustomEvent('l:hasVisitedBefore', { bubbles: true, detail: { isReturningCustomer: true } })
		)

		return
	}

	// Either a first-time visitor or still in same session
	window.isReturningCustomer = false
	document.dispatchEvent(
		new CustomEvent('l:hasVisitedBefore', { bubbles: true, detail: { isReturningCustomer: false } })
	)

	console.log({ isReturningCustomer: window.isReturningCustomer })

	return false
}

function hideEmptyIframe() {
	const iframes = document.querySelectorAll('iframe')

	iframes.forEach((iframe) => {
		console.log(iframe.src)

		if (iframe.src === 'about:blank' || !iframe.src) {
			console.log(iframe)

			iframe.style.display = 'none'
		}
	})

	document.body.classList.remove('js-hidden-iframes')
}

/**************************************
 * RUN GLOBAL FUNCTIONS
 ***************************************/
document.addEventListener('DOMContentLoaded', function () {
	l_isReturningVisitorAfterSession()
	hideEmptyIframe()
})

window.upcartOnCartUpdated = (data) => {
	document.documentElement.dispatchEvent(new CustomEvent('l-cart:updated', { bubbles: true, detail: { data } }))
}

/*============================================================================
  l-collection-progress-bar
==============================================================================*/
if (!customElements.get('l-collection-progress-bar')) {
	customElements.define(
		'l-collection-progress-bar',
		class CollectionProgressBar extends HTMLElement {
			constructor() {
				super()

				this.sectionID = this.dataset.sectionId
				this.$text = this.querySelector('[data-text]')
				this.$progress = this.querySelector('[data-progress]')
				this.$qtyText = this.querySelector('[data-qty-text]')
				this.$discountText = this.querySelector('[data-discount-text]')
			}

			connectedCallback() {
				this.setupEvents()

				const updateEvents = [
					'ajaxProduct:added',
					'cart:quantity.cart-cart-drawer',
					'cart:quantity.cart-header',
					'cart:updated',
				]

				updateEvents.forEach((eventName) => {
					document.addEventListener(eventName, this.updateSection.bind(this))
				})
			}

			setupEvents() {
				this.viewCartBtn = this.querySelector('[data-view-cart-btn]')

				if (!this.viewCartBtn) return

				this.viewCartBtn.addEventListener('click', () => {
					document.dispatchEvent(
						new CustomEvent('cart:open', {
							bubbles: true,
						})
					)
				})
			}

			updateSection() {
				console.log(`${window.theme.routes.home}?sections=${this.sectionID}`)

				fetch(`${window.theme.routes.home}?sections=${this.sectionID}`)
					.then((response) => response.json())
					.then((data) => {
						const newProgressBar = new DOMParser()
							.parseFromString(data[this.sectionID], 'text/html')
							.querySelector('l-collection-progress-bar')

						console.log(newProgressBar)

						this.$progress.innerHTML = newProgressBar.querySelector('[data-progress]').innerHTML
						this.$text.classList.remove('is-qty-0', 'is-qty-more', 'is-qty-congrats')
						this.$text.classList.add(newProgressBar.querySelector('[data-text]').dataset.text)

						this.$qtyText.innerHTML = newProgressBar.querySelector('[data-qty-text]').innerHTML
						this.$discountText.innerHTML = newProgressBar.querySelector('[data-discount-text]').innerHTML
					})
					.catch((error) => {
						console.log(error)
					})
					.then(() => {
						this.setupEvents()
					})
			}
		}
	)
}

/*============================================================================
  product-card-form
==============================================================================*/
if (!customElements.get('product-card-form')) {
	customElements.define(
		'product-card-form',
		class ProductCardForm extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				this.form = this.querySelector('form')

				if (this.form) {
					this.addToCart = this.form.querySelector('.add-to-cart')
					this.form.addEventListener('submit', this.addItemFromForm.bind(this))
				} else {
					console.log(this)
				}
			}

			addItemFromForm(event) {
				event.preventDefault()

				// Loading indicator on add to cart button
				this.addToCart.classList.add('btn--loading')

				const data = theme.utils.serialize(this.form)

				fetch(theme.routes.cartAdd, {
					method: 'POST',
					body: data,
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'X-Requested-With': 'XMLHttpRequest',
					},
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.status === 422) {
							this.form.dispatchEvent(
								new CustomEvent('ajaxProduct:error', {
									detail: {
										errorMessage: data.description,
									},
									bubbles: true,
								})
							)
						} else {
							const product = data
							this.form.dispatchEvent(
								new CustomEvent('ajaxProduct:added', {
									detail: {
										product: product,
										addToCartBtn: this.addToCart,
										openCartDrawer: this.hasAttribute('data-open-drawer'),
									},
									bubbles: true,
								})
							)
						}

						this.addToCart.classList.remove('btn--loading')

						// Reload page if adding product from a section on the cart page
						if (document.body.classList.contains('template-cart')) {
							window.scrollTo(0, 0)
							location.reload()
						}
					})
			}
		}
	)
}

/*============================================================================
  l-cart-drawer-progress-bar
==============================================================================*/
if (!customElements.get('l-cart-drawer-progress-bar')) {
	customElements.define(
		'l-cart-drawer-progress-bar',
		class CartDrawerProgressBar extends HTMLElement {
			constructor() {
				super()

				this.sectionID = this.dataset.sectionId
			}

			connectedCallback() {
				const eventNames = ['ajaxProduct:added', 'cart:updated']

				eventNames.forEach((eventName) => {
					document.addEventListener(eventName, () => {
						this.updateSection(eventName)
					})
				})
			}

			updateSection(eventName) {
				fetch(`${window.theme.routes.home}?sections=${this.sectionID}`)
					.then((response) => response.json())
					.then((data) => {
						const newProgressBar = new DOMParser()
							.parseFromString(data[this.sectionID], 'text/html')
							.querySelector('l-cart-drawer-progress-bar')

						if (newProgressBar) this.innerHTML = newProgressBar.innerHTML
					})
					.catch((error) => {
						console.log(error)
					})
			}
		}
	)
}

if (!customElements.get('l-cart-drawer-upsell-groups')) {
	customElements.define(
		'l-cart-drawer-upsell-groups',
		class CartDrawerUpselGroups extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				const groupQty = parseInt(this.dataset.groupsQty)

				console.log(groupQty)

				if (groupQty <= 1) return

				document.addEventListener('drawerOpen.CartDrawer', () => {
					const carousel = this.querySelector('[data-carousel]')
					const upSellGroups = this.querySelectorAll('[data-group]')

					upSellGroups.forEach((upSellGroup) => {
						upSellGroup.removeAttribute('hidden')
					})

					const flkty = new Flickity(carousel, {
						cellAlign: 'center',
						contain: true,
						pageDots: false,
						adaptiveHeight: true,
						wrapAround: false,
					})
				})
			}
		}
	)
}

if (!customElements.get('l-cart-drawer-upsell-sliders')) {
	customElements.define(
		'l-cart-drawer-upsell-sliders',
		class CartDrawerUpsellSlider extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				let carouselLoaded = false
				document.addEventListener('drawerOpen.CartDrawer', () => {
					if (carouselLoaded) return

					const announcementSliders = this.querySelectorAll('[data-slide]')

					announcementSliders.forEach((announcementSlider) => {
						announcementSlider.removeAttribute('hidden')
					})

					const flkty = new Flickity(this, {
						cellAlign: 'center',
						contain: true,
						pageDots: false,
						adaptiveHeight: true,
						wrapAround: false,
						prevNextButtons: true,
						autoPlay: 3000,
						pauseAutoPlayOnHover: true,
					})

					carouselLoaded = true
				})
			}
		}
	)
}

if (!customElements.get('l-cart-drawer-announcement-bar-slider')) {
	customElements.define(
		'l-cart-drawer-announcement-bar-slider',
		class CartDrawerAnnouncementBar extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				let carouselLoaded = false
				document.addEventListener('drawerOpen.CartDrawer', () => {
					if (carouselLoaded) return

					theme.utils.debounce(1000, () => {
						const announcementSliders = this.querySelectorAll('[data-slide]')

						console.log(announcementSliders)

						announcementSliders.forEach((announcementSlider) => {
							announcementSlider.classList.remove('hidden')
						})

						const flkty = new Flickity(this, {
							cellAlign: 'center',
							contain: true,
							wrapAround: true,
							adaptiveHeight: true,
							pageDots: false,
							prevNextButtons: false,
							autoPlay: 3000,
							pauseAutoPlayOnHover: true,
						})

						carouselLoaded = true
					})()
				})
			}
		}
	)
}

/*============================================================================
  l-product-lifestyle-images
==============================================================================*/
if (!customElements.get('l-product-lifestyle-images')) {
	customElements.define(
		'l-product-lifestyle-images',
		class ProductPageLifeStyleImages extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				const carousel = this.querySelector('[data-carousel]')

				const flkty = new Flickity(carousel, {
					cellAlign: 'center',
					contain: true,
					pageDots: true,
					adaptiveHeight: true,
					wrapAround: false,
					prevNextButtons: true,
				})
			}
		}
	)
}

/**************************************
 * L-STOCK-HELLO-BANNER
 ***************************************/
if (!customElements.get('l-stock-hello-banner')) {
	customElements.define(
		'l-stock-hello-banner',
		class LTAStockHelloBanner extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				if (window.isReturningCustomer) {
					this.classList.toggle('is-hidden', !window.isReturningCustomer)
				} else {
					document.addEventListener('l:hasVisitedBefore', (event) => {
						const isReturningCustomer = event.detail.isReturningCustomer

						this.classList.toggle('is-hidden', !isReturningCustomer)
					})
				}

				document.addEventListener('l-cart:updated', (event) => {
					const data = event.detail.data
					const itemCount = parseInt(data?.item_count || 0)

					this.classList.toggle('is-hidden', itemCount <= 0)
				})
			}
		}
	)
}

/**************************************
 * L-PDP-PROGRESS-BAR
 ***************************************/
if (!customElements.get('l-product-progress-bar')) {
	customElements.define(
		'l-product-progress-bar',
		class LProductProgressBar extends HTMLElement {
			constructor() {
				super()

				this.textEl = this.querySelector('[data-text]')
				this.thresholdEls = this.querySelectorAll('[data-threshold]')

				this.sectionID = this.dataset.sectionId
				this.thresholds = Array.from(this.thresholdEls).map((el) => ({
					name: el.dataset.thresholdName,
					value: parseInt(el.dataset.threshold, 10),
				}))

				// Events
				this.getData()

				const updateEvents = [
					'ajaxProduct:added',
					'cart:quantity.cart-cart-drawer',
					'cart:quantity.cart-header',
					'cart:updated',
				]

				updateEvents.forEach((eventName) => {
					document.addEventListener(eventName, this.getData.bind(this))
				})

				window.upcartOnCartUpdated = (data) => {
					document.documentElement.dispatchEvent(new CustomEvent('l-cart:updated', { bubbles: true, detail: { data } }))

					this.getData()
				}
			}

			async getData() {
				// Static data

				// Get Data
				this.cartData = await this.getCartData()
				this.productData = this.productData || (await this.getProductData())

				this.style.display = this.cartData.item_count >= 1 ? 'block' : 'none'

				// Check cart progress
				const cartTotal = this.cartData.total_price
				const minimumThreshold = this.thresholds.reduce(
					(min, threshold) => (threshold.value < min.value ? threshold : min),
					this.thresholds[0]
				)
				const maximumThreshold = this.thresholds.reduce(
					(max, threshold) => (threshold.value > max.value ? threshold : max),
					this.thresholds[0]
				)

				const currentPercentage = Math.min(100, Math.max(0, Math.round((cartTotal / maximumThreshold.value) * 100)))

				// Get collection url
				let collectionURL = `<a href="/pages/bandanas">See All Bandanas</a>`
				if (this.productData.type == 'Scarf') {
					collectionURL = `<a href="/pages/scarves">See All Scarves</a>`
				} else if (this.productData.type == 'Ring') {
					collectionURL = `<a href="/pages/rings">See All Rings</a>`
				}

				// Get status text
				let statusText = ''

				if (cartTotal < minimumThreshold.value) {
					statusText = `You’re ${this.formatMoney(minimumThreshold.value - cartTotal)} away from  ${minimumThreshold.name}! ${collectionURL}`
				}

				if (cartTotal >= minimumThreshold.value) {
					statusText = `You’re ${this.formatMoney(maximumThreshold.value - cartTotal)} away from  ${maximumThreshold.name}! ${collectionURL}`
				}

				if (cartTotal >= maximumThreshold.value) {
					statusText = `${maximumThreshold.name} unlocked! ${collectionURL}`
				}

				// Update UI
				this.thresholdEls.forEach((el) => {
					el.classList.toggle('is-active', parseInt(el.dataset.threshold, 10) <= cartTotal)
				})
				this.style.setProperty('--l-progress', `${currentPercentage}%`)
				this.textEl.innerHTML = statusText

				this.classList.remove('is-skeleton')
			}

			async getCartData() {
				return fetch(theme.routes.cart)
					.then((response) => response.json())
					.then((data) => {
						return data
					})
					.catch((error) => {
						console.log(error)
					})
			}

			async getProductData() {
				const url = new URL(window.location.href)
				url.search = ''
				const cleanUrl = url.toString()

				return fetch(`${cleanUrl}.js`)
					.then((response) => response.json())
					.then((data) => {
						return data
					})
					.catch((error) => {
						console.log(error)
					})
			}

			formatMoney(cents, format = '') {
				let value = ''
				const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
				const formatString = format || '${{amount}}'

				if (typeof cents == 'string') {
					cents = cents.replace('.', '')
				}

				function defaultOption(opt, def) {
					return typeof opt == 'undefined' ? def : opt
				}

				function formatWithDelimiters(number, precision, thousands, decimal) {
					precision = defaultOption(precision, 2)
					thousands = defaultOption(thousands, ',')
					decimal = defaultOption(decimal, '.')

					if (isNaN(number) || number == null) {
						return 0
					}

					number = (number / 100.0).toFixed(precision)

					var parts = number.split('.'),
						dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
						cents = parts[1] ? decimal + parts[1] : ''

					return dollars + cents
				}

				switch (formatString.match(placeholderRegex)[1]) {
					case 'amount':
						value = formatWithDelimiters(cents, 2)
						break
					case 'amount_no_decimals':
						value = formatWithDelimiters(cents, 0, ' ', '.')
						break
					case 'amount_with_comma_separator':
						value = formatWithDelimiters(cents, 2, '.', '.')
						break
					case 'amount_no_decimals_with_comma_separator':
						value = formatWithDelimiters(cents, 0, '.', '.')
						break
				}

				return formatString.replace(placeholderRegex, value)
			}
		}
	)
}

/**************************************
 * L-SWIPER-CAROUSEL
 ***************************************/
if (!customElements.get('l-swiper-carousel')) {
	customElements.define(
		'l-swiper-carousel',
		class LTASwiperCarousel extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Check if Swiper is already loaded
				if (window.Swiper) {
					this.setupCarousel()

					return
				}

				document.addEventListener('l:vendor:loaded', () => {
					console.log('Swiper is loaded, setting up carousel for')

					this.setupCarousel()
				})
			}

			setupCarousel() {
				this.carouselConfig = JSON.parse(this.querySelector('[data-carousel-config]').textContent)

				if (!this.carouselConfig) return

				this.swiperSlideEls = this.querySelectorAll('.swiper-slide')

				this.classList.remove('is-placeholder')
				this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

				this.swiperCarousel = new window.Swiper(this, this.carouselConfig)

				this.swiperCarousel.on('slideChange', function (swiper) {
					const activeSlideIndex = swiper.activeIndex + 1
				})

				Shopify.designMode && this.designModeScroll()
			}

			designModeScroll() {
				document.addEventListener('shopify:block:select', (event) => {
					const targetEl = event.target

					this.swiperSlideEls.forEach((swiperSlide, index0) => {
						if (targetEl == swiperSlide) this.slideTo(index0)
					})
				})
			}

			slideTo(index = 0) {
				this.swiperCarousel.slideTo(index)
			}
		}
	)
}

